import { Component, Directive, ChangeDetectionStrategy } from '@angular/core';

@Directive({
    selector: 'medpace-card-header',
    standalone: false,
})
export class MedpaceCardHeaderDirective {}

@Directive({
    selector: 'medpace-card-content',
    standalone: false,
})
export class MedpaceCardContentDirective {}

@Component({
    selector: 'medpace-card',
    standalone: false,
    templateUrl: './medpace-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./medpace-card.component.scss'],
})
export class MedpaceCardComponent {}
